import { useCallback } from 'react';
import { StaticCanvas } from 'fabric';
import { initAllPills } from '../utils/hydrate-pills';

/** Re-attach pill listeners. Call after loadFromJSON. */
export const usePillHydration = (canvas: StaticCanvas | null) =>
  useCallback(() => {
    if (!canvas) return;
    initAllPills(canvas);
  }, [canvas]);
